module.exports = __webpack_public_path__ + "assets/LozengeDetailed.bec74b2339c825fa6a6c14b813c5433f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LozengeDetailed.png
// module id = 537
// module chunks = 0